var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnregistrer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.97,77.64V24.39h144.64c-0.24,6.13-0.4,12.21-0.4,18.14c0,7.12,5.42,51.59-4.82,52.93H195.8 C180.3,95.47,177.97,93.17,177.97,77.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.18,112.35v326.39c0,13.16-10.67,23.84-23.84,23.84h-71.31V344.46c0-10.87-8.81-19.65-19.65-19.65H145.83 c-10.87,0-19.65,8.78-19.65,19.65v118.11H54.88C41.71,462.58,31,451.9,31,438.74V48.27c0-13.2,10.71-23.88,23.88-23.88h93.45v32.53 c0,21.46-4.94,50.6,17.08,63.48c9.37,5.49,20.08,4.7,30.4,4.7h121.59c2.02-0.28,3.95-0.63,5.73-1.07c0.04,0,0.04,0,0.04,0 c26.96-6.4,28.7-29.57,28.7-54.43V24.39h27.51c6.21,0,12.17,2.41,16.6,6.76l65.97,64.08C466.57,99.74,469.18,105.9,469.18,112.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.2,125.11h4.19C315.85,125.31,314.46,125.31,313.2,125.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.12,124.05c-1.66,0.67-3.56,1.07-5.73,1.07C319.41,124.84,321.34,124.48,323.12,124.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnregistrer);
export default __webpack_public_path__ + "static/media/enregistrer.e386255a3cec103c2ec621b2dac7fb51.svg";
export { ForwardRef as ReactComponent };